module.exports = __webpack_public_path__ + "img/125.c182870e.jpg";